import { render, staticRenderFns } from "./ReportActBtn.vue?vue&type=template&id=24e4452e&"
import script from "./ReportActBtn.vue?vue&type=script&lang=js&"
export * from "./ReportActBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports